import "../styles/AboutUs.css";
import { Typography, Button, AppBar, Toolbar, Grid2} from "@mui/material";
import logo from "../assets/LOGO.jpg";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { useState} from "react";


const AboutUs = ()=>{
  const [showPhoneModal, setShowPhoneModal] = useState(false);
  const mapContainerStyle = {
    width: "100%",
    height: "100%",
  };

  const center = {
    lat: 26.07687,
    lng: -80.21041,
  };
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        fade: true,
        nextArrow: null,
        prevArrow: null,
      };
    return(
    <div className="about-us">
        <div className="header-about-us">
          <AppBar color="white">
            <Toolbar>
              <Grid2 container alignItems="center" className="header-Grid2-us">
                <Grid2 item>
                    <img className="logo" src={logo} alt="logo"/>
                    </Grid2>
                <Grid2 item>
                <Link to='/'><Button color="inherit" >Home</Button></Link>
                </Grid2>
                <Grid2 item>
                <Link to='/PartsEngineSales'><Button color="inherit" >Parts & Engine Sales</Button></Link>
                </Grid2>
                <Grid2 item>
                <Link to='/Service'><Button color="inherit" > Service</Button></Link>
                </Grid2>
                <Grid2 item>
                <Link to='/OtherBrands'><Button color="inherit"> Other Brands</Button></Link>
                </Grid2>
                <Grid2 item>
                <Link to='#'><Button color="inherit" > About US</Button></Link>
                </Grid2>
                <Grid2 item xs />
                <Grid2 item>
                <a href="mailto:fitoto9349@nalwan.com"><Button className="contact-button" >Contact Us</Button></a>
                </Grid2>
              </Grid2>
            </Toolbar>
          </AppBar>
          
        </div>
        <a href="https://wa.me/+17542622405" target="whatsapp" className="whatsapp-button">
          <svg xmlns="http://www.w3.org/2000/svg" width={60} height={60} viewBox="0 0 256 258">
            <defs>
              <linearGradient id="logosWhatsappIcon0" x1="50%" x2="50%" y1="100%" y2="0%">
                <stop offset="0%" stopColor="#1faf38"></stop>
                <stop offset="100%" stopColor="#60d669"></stop>
              </linearGradient>
              <linearGradient id="logosWhatsappIcon1" x1="50%" x2="50%" y1="100%" y2="0%">
                <stop offset="0%" stopColor="#f9f9f9"></stop>
                <stop offset="100%" stopColor="#fff"></stop>
              </linearGradient>
            </defs>
            <path fill="url(#logosWhatsappIcon0)" d="M5.463 127.456c-.006 21.677 5.658 42.843 16.428 61.499L4.433 252.697l65.232-17.104a123 123 0 0 0 58.8 14.97h.054c67.815 0 123.018-55.183 123.047-123.01c.013-32.867-12.775-63.773-36.009-87.025c-23.23-23.25-54.125-36.061-87.043-36.076c-67.823 0-123.022 55.18-123.05 123.004"></path>
            <path fill="url(#logosWhatsappIcon1)" d="M1.07 127.416c-.007 22.457 5.86 44.38 17.014 63.704L0 257.147l67.571-17.717c18.618 10.151 39.58 15.503 60.91 15.511h.055c70.248 0 127.434-57.168 127.464-127.423c.012-34.048-13.236-66.065-37.3-90.15C194.633 13.286 162.633.014 128.536 0C58.276 0 1.099 57.16 1.071 127.416m40.24 60.376l-2.523-4.005c-10.606-16.864-16.204-36.352-16.196-56.363C22.614 69.029 70.138 21.52 128.576 21.52c28.3.012 54.896 11.044 74.9 31.06c20.003 20.018 31.01 46.628 31.003 74.93c-.026 58.395-47.551 105.91-105.943 105.91h-.042c-19.013-.01-37.66-5.116-53.922-14.765l-3.87-2.295l-40.098 10.513z"></path>
            <path fill="#fff" d="M96.678 74.148c-2.386-5.303-4.897-5.41-7.166-5.503c-1.858-.08-3.982-.074-6.104-.074c-2.124 0-5.575.799-8.492 3.984c-2.92 3.188-11.148 10.892-11.148 26.561s11.413 30.813 13.004 32.94c1.593 2.123 22.033 35.307 54.405 48.073c26.904 10.609 32.379 8.499 38.218 7.967c5.84-.53 18.844-7.702 21.497-15.139c2.655-7.436 2.655-13.81 1.859-15.142c-.796-1.327-2.92-2.124-6.105-3.716s-18.844-9.298-21.763-10.361c-2.92-1.062-5.043-1.592-7.167 1.597c-2.124 3.184-8.223 10.356-10.082 12.48c-1.857 2.129-3.716 2.394-6.9.801c-3.187-1.598-13.444-4.957-25.613-15.806c-9.468-8.442-15.86-18.867-17.718-22.056c-1.858-3.184-.199-4.91 1.398-6.497c1.431-1.427 3.186-3.719 4.78-5.578c1.588-1.86 2.118-3.187 3.18-5.311c1.063-2.126.531-3.986-.264-5.579c-.798-1.593-6.987-17.343-9.819-23.64"></path>
          </svg>
        </a>
            <Slider {...settings}>
        <div className="slider">
              <img src={require("../assets/_W3A6784.jpg")} className="about-us-image" alt="Expert Dieselt" />
            </div>
            <div>
              <img src={require("../assets/_W3A7207.jpg")} className="about-us-image" alt="Expert Diesel" />
            </div>
            <div>
              <img src={require("../assets/_W3A72301.jpg")} className="about-us-image" alt="Expert Diesel" />
            </div>
            <div>
              <img src={require("../assets/_W3A7242.jpg")} className="about-us-image" alt="Expert Diesel" />
            </div>
            <div>
              <img src={require("../assets/_W3A7261.jpg")} className="about-us-image" alt="Expert Diesel" />
            </div>
            <div>
              <img src={require("../assets/_W3A7305.jpg")} className="about-us-image" alt="Expert Diesel" />
            </div>
      </Slider>
      <p variant="h3" className="about-us-title">ABOUT US</p>
        <div className="about-us-content">
            
            <p className="about-us-text">
    <strong>Since 1988, for over 35 years Expert Diesel has been one of the best and most experienced diesel engine repair, service, sales and parts company in South Florida. Specializing in Cummins engines, we are certified on all levels of Cummins engines including Marine, Industrial and Truck. We are an Authorized Cummins Service Center and Autocar Service Center, capable of working on all engine types and sizes from the Little Bs to the Big QSKs.
    We always have over 20 full-time, trained technicians and parts personnel on staff ready to meet your needs.<br /><br />
    Certified in the following Cummins engines:</strong>
  </p>
  <ul className="about-us-list">
    <li><strong>Marine</strong></li>
    <li><strong>Industrial</strong></li>
    <li><strong>Truck</strong></li>
  </ul>
  <p className="about-us-text">
    <strong>Here are a few of the companies that choose Expert Diesel for their diesel, Autocar, and Cummins engine service needs:</strong>
  </p>
  <ul className="about-us-list">
    <li><strong>Ryder</strong></li>
    <li><strong>Penske</strong></li>
    <li><strong>Waste Management</strong></li>
    <li><strong>UPS</strong></li>
    <li><strong>Marine Max</strong></li>
    <li><strong>Choice Environmental Services</strong></li>
    <li><strong>City of Sunrise</strong></li>
    <li><strong>Davie Fire Department</strong></li>
    <li><strong>Pembroke Pines Fire Department</strong></li>
  </ul>
  <p className="about-us-text">
    <strong>Reasons to Choose Expert Diesel</strong>
  </p>
        </div>
        <div className="footer">
        <Grid2 container spacing={2} className="footer-container">
        <Grid2 item xs={12} md={6} className="footer-right">
              <div className="map-container">
                <LoadScript googleMapsApiKey="AIzaSyBN6CqhMJnBIJnFR2NwAFBC4ya2XdHVKoc">
                  <GoogleMap
                    mapContainerStyle={mapContainerStyle}
                    center={center}
                    zoom={14}
                  >
                    <Marker position={center} title="My location" />
                  </GoogleMap>
                  <div className="map-info">
                    <p className='map-text'>EXPERT DIESEL | 4700 OAKES RD | HOLLYWOOD, FL 33314</p>
                    <h6 className='call-us-text'>CALL US TODAY AT 954-583-2400 FOR MORE INFORMATION!!</h6>
                  </div>
                </LoadScript>
              </div>
            </Grid2>
            <Grid2 item xs={12} md={6} className="footer-left">
              <Typography variant="h4" className="some-our-main">SOME OUR MAIN CUSTOMERS</Typography>
              <Typography variant="h6" className="some-our-text">We provide Cummins, Autocar and diesel engine service and repairs for all of South Florida, including the following counties and cities:</Typography>
              <Typography variant="h6" className="some-our-list">
                <Grid2 container className="list">
                  <Grid2 item xs={6}>
                    <ul>
                      <li>Broward County</li>
                      <li>Miami-Dade County</li>
                      <li>Fort Lauderdale</li>
                      <li>Plantation</li>
                      <li>Sunrise</li>
                      <li>Pembroke Pines</li>
                      <li>Cooper City</li>
                      <li>Davie</li>
                      <li>Coral Springs</li>
                      <li>Tamarac</li>
                      <li>Boca Raton</li>
                    </ul>
                  </Grid2>
                  <Grid2 item xs={6}>
                    <ul>
                      <li>Delray Beach</li>
                      <li>Deerfield Beach</li>
                      <li>Pompano Beach</li>
                      <li>Hollywood</li>
                      <li>Aventura</li>
                      <li>North Miami Beach</li>
                      <li>Kendall</li>
                      <li>Miami Beach</li>
                      <li>Miami</li>
                      <li>Key Biscayne</li>
                      <li>Many more!!!</li>
                    </ul>
                  </Grid2>
                </Grid2>
              </Typography>
            </Grid2>
          </Grid2>
          </div>
      <div className="connect-with-us">
      <Typography variant="h4">CONNECT WITH US</Typography>
            {showPhoneModal && (
            <div className="aviso">
              <div className="aviso-content">
                <button className="close-btn-aviso" onClick={() => setShowPhoneModal(false)}>
                  &times;
                </button>
                <p className="aviso-title">CONTACT</p>
                <p className="aviso-text">Our contact number is: +1 (954)-583-2400</p>
              </div>
            </div>
          )}
          <Grid2 container spacing={2}>
            <Grid2 item xs={12} md={4} className="logo-section" onClick={() => setShowPhoneModal(true)} style={{ cursor: 'pointer', textAlign: 'center' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24"><path fill="currentColor" d="M12 2C6.486 2 2 6.486 2 12v4.143C2 17.167 2.897 18 4 18h1a1 1 0 0 0 1-1v-5.143a1 1 0 0 0-1-1h-.908C4.648 6.987 7.978 4 12 4s7.352 2.987 7.908 6.857H19a1 1 0 0 0-1 1V18c0 1.103-.897 2-2 2h-2v-1h-4v3h6c2.206 0 4-1.794 4-4c1.103 0 2-.833 2-1.857V12c0-5.514-4.486-10-10-10"></path></svg>
              <Typography variant="body1" style={{fontWeight:'bold', paddingTop:'10px'}}>GET SUPPORT</Typography>
            </Grid2>
            <hr className="logo-divider" />
            <Grid2 item xs={12} md={4} className="logo-section">
            <Link to="/PartsEngineSales#form-section" className="request-quote-button">
              <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
                <path fill="currentColor" d="M6 22q-.825 0-1.412-.587T4 20V4q0-.825.588-1.412T6 2h8l6 6v12q0 .825-.587 1.413T18 22zm5-3h2v-1h1q.425 0 .713-.288T15 17v-3q0-.425-.288-.712T14 13h-3v-1h4v-2h-2V9h-2v1h-1q-.425 0-.712.288T9 11v3q0 .425.288.713T10 15h3v1H9v2h2zm2.175-11h4l-4-4z"></path>
              </svg>
              <Typography variant="body1" style={{fontWeight:'bold', paddingTop:'10px'}}>REQUEST A QUOTE</Typography>
            </Link>
            </Grid2>
            <hr className="logo-divider" />
            <Grid2 item xs={12} md={4} className="logo-section">
              <Link to="/Service#form-section-serv" style={{ textDecoration: 'none', color: 'inherit', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <svg xmlns="http://www.w3.org/2000/svg" width={512} height={512} viewBox="0 0 512 512"><path fill="currentColor" d="M80.08 82.66L60.24 102.5L192.9 242.7v58.6h78v-50.9zm-25.4 40.14v80.3l4.01 2.7c10.56 7 14.74 14.1 15.93 19.8c1.18 5.8-.43 10.8-3.85 14.9c-6.86 8.3-19.91 12.3-32.73-.6l-12.72 12.8c19.18 19.1 46.13 15.1 59.27-.6c6.58-7.9 9.97-18.9 7.65-30.1c-2.05-10-8.72-19.7-19.56-28v-52.2zm258.02 52.5v144h-185c22.6 5.8 40.6 23.5 46.7 46H337c7.5-27.6 32.8-48 62.7-48s55.2 20.4 62.7 48h24.3v-84.6l-60.2-105.4zm36 14h62.1l54.7 92H348.7v-83zm-321.49 130l11.5 46h10.25c6.12-22.5 24.09-40.2 46.74-46zm84.49 16c-26.08 0-47.02 20.9-47.02 47s20.94 47 47.02 47c26.1 0 47-20.9 47-47s-20.9-47-47-47m288 0c-26.1 0-47 20.9-47 47s20.9 47 47 47s47-20.9 47-47s-20.9-47-47-47"></path></svg>
                <Typography variant="body1" style={{ fontWeight: 'bold', paddingTop: '10px' }}>
                  REQUEST A SERVICE
                </Typography>
              </Link>
            </Grid2>        
          </Grid2>
          <Typography variant="body1" className="connect-text"> © 2024 Expert diesel, Box 3005, Columbus, IN 47202-3005 U.S.A.</Typography>
          <Grid2 container spacing={2} className="social-buttons">
            <Grid2 item xs={12} md={2}>
              <Button className="social-button">ACCESIBILITY</Button>
            </Grid2>
            <Grid2 item xs={12} md={2}>
              <Button className="social-button">PRIVACY POLICY</Button>
            </Grid2>
            <Grid2 item xs={12} md={2}>
              <Button className="social-button">TERMS OF USE</Button>
            </Grid2>
            <Grid2 item xs={12} md={2}>
              <Button className="social-button">COOKIE NOTICE</Button>
            </Grid2>
            <Grid2 item xs={12} md={2}>
              <Button className="social-button">SITE MAP</Button>
            </Grid2>
            <Grid2 item xs={12} md={2} className="logo-buttons">
              <Button className="logo-button">
              <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24"><path fill="white" d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4zm9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8A1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3"></path></svg>
              </Button>
              <Button className="logo-button">
              <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24"><g fill="none"><path d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z"></path><path fill="white" d="M12 4c.855 0 1.732.022 2.582.058l1.004.048l.961.057l.9.061l.822.064a3.8 3.8 0 0 1 3.494 3.423l.04.425l.075.91c.07.943.122 1.971.122 2.954s-.052 2.011-.122 2.954l-.075.91l-.04.425a3.8 3.8 0 0 1-3.495 3.423l-.82.063l-.9.062l-.962.057l-1.004.048A62 62 0 0 1 12 20a62 62 0 0 1-2.582-.058l-1.004-.048l-.961-.057l-.9-.062l-.822-.063a3.8 3.8 0 0 1-3.494-3.423l-.04-.425l-.075-.91A41 41 0 0 1 2 12c0-.983.052-2.011.122-2.954l.075-.91l.04-.425A3.8 3.8 0 0 1 5.73 4.288l.821-.064l.9-.061l.962-.057l1.004-.048A62 62 0 0 1 12 4m0 2c-.825 0-1.674.022-2.5.056l-.978.047l-.939.055l-.882.06l-.808.063a1.8 1.8 0 0 0-1.666 1.623C4.11 9.113 4 10.618 4 12s.11 2.887.227 4.096c.085.872.777 1.55 1.666 1.623l.808.062l.882.06l.939.056l.978.047c.826.034 1.675.056 2.5.056s1.674-.022 2.5-.056l.978-.047l.939-.055l.882-.06l.808-.063a1.8 1.8 0 0 0 1.666-1.623C19.89 14.887 20 13.382 20 12s-.11-2.887-.227-4.096a1.8 1.8 0 0 0-1.666-1.623l-.808-.062l-.882-.06l-.939-.056l-.978-.047A61 61 0 0 0 12 6m-2 3.575a.6.6 0 0 1 .819-.559l.081.04l4.2 2.424a.6.6 0 0 1 .085.98l-.085.06l-4.2 2.425a.6.6 0 0 1-.894-.43l-.006-.09z"></path></g></svg>
              </Button>
              <Button className="logo-button">
              <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24"><path fill="white" d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zm-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93zM6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37z"></path></svg>
              </Button>
              <Button className="logo-button">
              <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20"><path fill="white" fillRule="evenodd" d="M18.896 0H1.104C.494 0 0 .494 0 1.104v17.792C0 19.506.494 20 1.104 20h9.578v-7.745H8.076V9.237h2.606V7.01c0-2.584 1.578-3.99 3.883-3.99c1.104 0 2.052.082 2.329.119v2.7h-1.598c-1.254 0-1.496.596-1.496 1.47v1.927h2.989l-.39 3.018h-2.6V20h5.097c.61 0 1.104-.494 1.104-1.104V1.104C20 .494 19.506 0 18.896 0"></path></svg>
              </Button>
            </Grid2>
          </Grid2>
        </div>
      </div>
    );
};
export default AboutUs;